<template>
    <section class="section project-activities-section pb-0">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <!-- Basic Heading -->
                    <h3><icon name="fa fa-puzzle-piece" class="mb-5 mr-2" size="lg" type="success" shadow rounded></icon>{{$t('Project_Activities')}}</h3>
                </div>  
                <div class="col-lg-12">
                    <div  class="timeline-scroll" id="infinite-list">
                    <div class="timeline"  >
                        <div  v-for="(activityItems,index) in activityData.campaign_activities.list" :key="index">
                        <div class="container-1 left" v-if="index%2==0">
                            <div class="content">
                                <div class="head">
                                    <div class="small">{{activityItems && activityItems.actual_start_date ? formatDate(activityItems.actual_start_date) :"NA"}}</div> 
                                    <div class="larg-title">{{activityItems ? activityItems.name : "NA"}}</div>
                                </div>
                                <div class="body">
                                    <div class="user-amount">
                                        {{$t('Spent_Amount')}} <span><i class="fa fa-rub" aria-hidden="true"></i> {{activityItems && activityItems.fund_used ? activityItems.fund_used : 0}}</span>
                                    </div>    
                                    <p>{{activityItems && activityItems.description  ? activityItems.description : "NA"}}</p>
                                     
                                     <p>
                                       <div class="list-group-1">
                                        <button v-if="activityItems.evidence_document" type="button" @click="downloadActivityEvidance(activityItems)" class="btn btn-outline-warning inline-btn"><span class="fa fa-download"></span> </button>
                                        <b-list-group-item class="inline-list">{{activityItems && activityItems.evidence_document ? activityItems.evidence_document.file_name : "No document found " }}</b-list-group-item>   
                                       </div>
                                    </p>                                
                                </div>
                           </div>
                        </div>
                        <div class="container-1 right" v-else>
                           <div class="content">
                                <div class="head">
                                    <div class="small">{{activityItems && activityItems.actual_start_date ? formatDate(activityItems.actual_start_date) :"NA"}}</div> 
                                    <div class="larg-title">{{activityItems ? activityItems.name : "NA"}}</div>
                                </div>
                                <div class="body">
                                    <div class="user-amount">
                                        {{$t('Spent_Amount')}} <span><i class="fa fa-rub" aria-hidden="true"></i> {{activityItems  && activityItems.fund_used ? activityItems.fund_used : 0}}</span>
                                    </div>    
                                    <p>{{activityItems && activityItems.description  ? activityItems.description : "NA"}}</p>
                                    <p>
                                       <div class="list-group-1">
                                        <button v-if="activityItems.evidence_document" type="button" @click="downloadActivityEvidance(activityItems)" class="btn btn-outline-warning inline-btn"><span class="fa fa-download"></span> </button>
                                        <b-list-group-item class="inline-list">{{activityItems && activityItems.evidence_document ? activityItems.evidence_document.file_name : "No document found " }}</b-list-group-item>   
                                       </div>
                                    </p>
                                </div>
                           </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>    
            </div>
        </div>
    </section>

</template>
<script>
import moment from "moment";
export default {
     props:['activityData'],   
    data(){
        return{
            
        }
    },
    mounted(){
        console.log("activity data",this.activityData);
    },
    methods:{
         
            downloadActivityEvidance(activityItems){
       window.open(activityItems.evidence_document.url, "_target");
       
        console.log("activity download file clicked",activityItems);

      },
        formatDate(date) {
            return moment.utc(date).format("YYYY/MM/DD");
        },
        // showCardData(){
        //     this.$emit("updateSelectedCardData",'#infinite-list')
        //     console.log("scroll called emit",document.querySelector('#infinite-list'));
        // }
    }
};
</script>
<style>
</style>
